import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, wheelMultiplier: 0.9 });
    window.lenis = lenis;
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); window.lenis = null; };
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const el = e.target.closest("[data-scroll]");
      if (!el) return;
      const id = el.getAttribute("data-scroll");
      e.preventDefault();
      if (location.pathname !== "/") {
        sessionStorage.setItem("scrollTo", id);
        navigate("/");
      } else if (window.lenis) {
        window.lenis.scrollTo(id, { offset: -80 });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (location.pathname === "/") {
      const target = sessionStorage.getItem("scrollTo");
      if (target) {
        sessionStorage.removeItem("scrollTo");
        setTimeout(() => window.lenis && window.lenis.scrollTo(target, { offset: -80 }), 300);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <div className="App grain bg-ink text-white">
      <Toaster position="top-center" theme="dark" richColors />
      <Header />
      <Outlet />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
